import { Component } from '@angular/core';

@Component({
  selector: 'free-services-parcels',
  templateUrl: './fsp-building-register.component.html',
  standalone: false,
})
export class FspBuildingRegisterComponent {
  constructor() {}
}
